import(/* webpackMode: "eager" */ "/workspace/app/forgot-password/page.js");
